import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Submit_Btn.css'
import { faAngleRight, faPlay } from '@fortawesome/free-solid-svg-icons'

const Submit_Btn = (props) => {
    return (
        <button className="Submit_Btn" type={props?.type ? props?.type : "button"} onClick={props?.onClick} >
{/* 
            <div className='icon_holder'>
                <FontAwesomeIcon icon={faPlay} className='icon' />
            </div> */}

            <p className='btn_text'>{props?.btn_name}</p>
        </button>
    )
}

export default Submit_Btn
